import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Accordion,
  Button,
  Grid,
  Icon,
  Input,
  Modal,
  Popup
} from 'semantic-ui-react';
import shortid from 'short-id';
import { toast } from 'react-toastify';
import {
  updateAdHold,
  insertAdNote,
  approveQC,
  clearAdQC
} from '../../../services/AdServiceManager';
import { updateStatusAd } from '../../../fbApi/Ad';
import getFullNameOrUserName from '../../../utils/user';
import * as AppActions from '../../../actions';
import AdNoteDetail from './AdNoteDetail';
import './AdNotesQC.css';

class AdNotesQC extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentNote: '',
      qC:
        props.adPreview.adQc && props.adPreview.adQc !== null
          ? props.adPreview.adQc
          : {},
      notes: props.adPreview.adNotes
        ? props.adPreview.adNotes.map((n) => n)
        : [],
      showHistory: false,
      hasQC: props.adPreview.adQc && props.adPreview.adQc !== null,
      showClearModal: false,
      qcNote: '',
      token: props.getFbToken(),
      processingSaveNote: false,
      allQcBoxesFilled: false,
      cancelOpen: false,
      qcProcessing: false,
      qcAllProcessing: false,
      clearProcessing: false,
      clearAllProcessing: false,
      holdProcessing: false
    };
  }

  componentDidMount() {
    this.initializeQc();
  }

  componentWillReceiveProps(nextProps) {
    const { isPreviewActive, expandAll } = this.props;
    const {
      isScrolling,
      isPreviewActive: nextIsPreviewActive,
      expandAll: nextExpandAll
    } = nextProps;
    const openedAll = !expandAll && nextExpandAll;
    const switchedActive = isPreviewActive !== nextIsPreviewActive;
    if (isScrolling || openedAll || switchedActive) {
      this.setState({
        ...this.state,
        qcNote: '',
        holdOpen: false,
        cancelOpen: false
      });
    }
  }

  initializeQc = () => {
    const { qC } = this.state;
    this.setState({
      ...this.state,
      allQcBoxesFilled:
        (qC.qc1 !== 'false' || qC.qc1 === null) &&
        (qC.qc2 !== 'false' || qC.qc2 === null)
    });
  };

  onCloseClearModal = () => {
    this.setState({ ...this.state, showClearModal: false });
  };

  handleSave = () => {
    const { adPreview, user } = this.props;
    this.setState({ ...this.state, processingSaveNote: true }, async () => {
      const { currentNote } = this.state;
      const adId = adPreview.ad_id;
      if (
        currentNote !== undefined &&
        currentNote !== null &&
        currentNote !== ''
      ) {
        const fullname = getFullNameOrUserName(user);
        const noteToInsert = {
          ad_id: adId,
          note_text: currentNote,
          username: user.email,
          fullname,
          note_qc: true,
          note_type: 0 // common note
        };
        const result = await insertAdNote(noteToInsert);
        const { allNotes } = result || {};
        const newStateAd = {
          ...adPreview,
          adNotes: allNotes || []
        };
        this.setState(
          { ...this.state, processingSaveNote: false, currentNote: '' },
          () => {
            this.updateParent(newStateAd);
            toast('Notes Successfully Saved!', {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 2000,
              type: toast.TYPE.SUCCESS,
              hideProgressBar: true
            });
          }
        );
      } else {
        toast('The note is blank.', {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 2000,
          type: toast.TYPE.WARNING,
          hideProgressBar: true
        });
        this.setState({
          ...this.state,
          processingSaveNote: false,
          currentNote: ''
        });
      }
    });
  };

  updateParent = (newAd, isHold = false) => {
    const { adNotes } = newAd;
    const { updateParentState } = this.props;
    this.setState(
      {
        ...this.state,
        notes: adNotes
      },
      () => {
        if (updateParentState) {
          updateParentState(newAd, isHold);
        }
      }
    );
  };
  insertNoteQC = async (adId, autoMessage, email, fullname, noteType) => {
    const qcNote =
      this.state.qcNote && this.state.qcNote !== ''
        ? this.state.qcNote
        : `${autoMessage} by ${fullname === '' ? email : fullname}`;
    const noteToInsert = {
      ad_id: adId,
      note_text: qcNote,
      username: email,
      fullname,
      note_qc: false,
      note_type: noteType
    };
    const { allNotes } = await insertAdNote(noteToInsert);
    const retrievedNotes = allNotes || [];
    this.setState({
      ...this.state,
      qcNote: '',
      notes: retrievedNotes
    });
    return retrievedNotes;
  };

  mapQCServiceObject = (result) => {
    const { returnQC } = result || {};
    const {
      qc_1: qc1,
      qc_2: qc2,
      ad_id: adId,
      qc_1_username: qc1Username,
      qc_2_username: qc2Username,
      qc_1_fullname: qc1Fullname,
      qc_2_fullname: qc2Fullname,
      on_hold: onHold,
      hold_qc_username: holdQcUsername,
      hold_qc_fullname: holdQcFullname,
      clear_qc_username: clearQcUsername,
      clear_qc_fullname: clearQcFullname
    } = returnQC;

    return {
      adId,
      qc1,
      qc2,
      qc1Username,
      qc2Username,
      qc2Fullname,
      qc1Fullname,
      on_hold: onHold,
      hold_qc_username: holdQcUsername,
      hold_qc_fullname: holdQcFullname,
      clear_qc_username: clearQcUsername,
      clear_qc_fullname: clearQcFullname
    };
  };

  processQCResult = async (result, fullname, email, adId) => {
    const { qcProcess, tabName, adSection, actions, adPreview } = this.props;
    const { returnQC } = result || {};
    const { qc_2: qc2 } = returnQC || {};
    if (qc2 && qc2 === 'true') {
      const qcAdsProgress = qcProcess;
      qcAdsProgress[tabName].totalQC = qcAdsProgress[tabName].totalQC + 1;
      let totalAds = 0;
      let totalQC = 0;
      Object.keys(qcAdsProgress).forEach((key) => {
        totalAds += qcAdsProgress[key].totalAds;
        totalQC += qcAdsProgress[key].totalQC;
      });
      const generalQCProgress = (totalQC * 100) / totalAds;
      actions.updateTotalQCAds(qcAdsProgress, generalQCProgress);
      if (adSection && adSection !== null && adSection !== '') {
        actions.updateCompareTotalQCAds(
          qcAdsProgress,
          generalQCProgress,
          adSection
        );
      }
    }
    const qcObject = this.mapQCServiceObject(result);
    const updatedNotes = await this.insertNoteQC(
      adId,
      'QC Approved',
      email,
      fullname,
      1
    );
    toast('QC Successfully Saved!', {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 2000,
      type: toast.TYPE.SUCCESS,
      hideProgressBar: true
    });
    const newStateAd = {
      ...adPreview,
      adQc: qcObject,
      adNotes: updatedNotes
    };
    this.setState(
      {
        ...this.state,
        hasQC: true,
        qC: qcObject,
        qcNote: ''
      },
      () => {
        this.updateParent(newStateAd);
      }
    );
  };

  checkIfAllQcSelected = () => {
    const { qC: adQc } = this.state;
    if (adQc) {
      const { qc1, qc2 } = adQc;
      const isQcDone = qc1 === 'true' && qc2 === 'true';
      return isQcDone;
    }
    return false;
  };

  checkIfAllQcFalse = () => {
    const { qC: adQc } = this.state;
    if (adQc) {
      const qc1 = adQc.qc_1 || adQc.qc1 || 'false';
      const qc2 = adQc.qc_2 || adQc.qc2 || 'false';
      const isAllQcFalse = qc1 === 'false' && qc2 === 'false';
      return isAllQcFalse;
    }
    return false;
  };

  approveQc = (approveAll) => {
    const stateParams = { ...this.state, cancelOpen: false, holdOpen: false };
    if (approveAll) {
      stateParams.qcAllProcessing = true;
    } else {
      stateParams.qcProcessing = true;
    }
    this.setState(stateParams, async () => {
      await this.approveNextQC(approveAll);
    });
  };

  approveNextQC = async (approveAll) => {
    const { user, adPreview } = this.props;
    const { email } = user;
    const { qC } = this.state;

    const fullname = getFullNameOrUserName(user);
    const adId = adPreview.ad_id;
    const qcInfo = {
      ad_id: adId,
      fullname,
      username: email,
      approveAll
    };

    if (
      ((qC.qc1 !== 'false' || qC.qc1 === null) &&
        (qC.qc2 !== 'false' || qC.qc2 === null)) ||
      approveAll
    ) {
      this.setState({
        ...this.state,
        allQcBoxesFilled: true
      });
    }

    const allFilled =
      (qC.qc1 !== 'false' || qC.qc1 === null) &&
      (qC.qc2 !== 'false' || qC.qc2 === null);

    // const isAllQcSelected = this.checkIfAllQcSelected();

    if (allFilled) {
      toast(`${adPreview.ad_name} has already been QC-ed.`, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 4000,
        type: toast.TYPE.WARNING,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
    } else {
      const result = await approveQC(qcInfo);
      await this.processQCResult(result, fullname, email, adId);
    }
    this.setState({
      ...this.state,
      qcProcessing: false,
      qcAllProcessing: false
    });
  };

  handleClear = (singleQc = false) => {
    const {
      user,
      adPreview,
      qcProcess,
      tabName,
      actions,
      adSection
    } = this.props;
    const { hasQC, qC } = this.state;
    const stateQc = qC;
    const { qc1, qc2 } = stateQc;
    const { email } = user;
    const fullname = getFullNameOrUserName(user);
    const adId = adPreview.ad_id;
    const qcAdInfo = {
      ad_id: adId,
      fullname,
      username: email
    };
    const isAllQcFalse = this.checkIfAllQcFalse();

    const nothingToQc = isAllQcFalse || !hasQC;

    if (nothingToQc) {
      toast('Cannot clear QC. The selected ad does not have QC.', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 3000,
        type: toast.TYPE.WARNING,
        hideProgressBar: true
      });
      this.setState({
        showClearModal: false,
        cancelOpen: false,
        clearProcessing: false,
        clearAllProcessing: false
      });
      return;
    }
    const initialStateParams = {
      ...this.state,
      cancelOpen: false,
      showClearModal: false,
      holdOpen: false
    };
    if (singleQc) {
      initialStateParams.clearProcessing = true;
    } else {
      initialStateParams.clearAllProcessing = true;
    }
    this.setState(initialStateParams, async () => {
      if (hasQC) {
        if (qc2 && qc2 === 'true') {
          const qcAdsProgress = qcProcess;
          qcAdsProgress[tabName].totalQC = qcAdsProgress[tabName].totalQC - 1;
          let totalAds = 0;
          let totalQC = 0;
          Object.keys(qcAdsProgress).forEach((key) => {
            totalAds += qcAdsProgress[key].totalAds;
            totalQC += qcAdsProgress[key].totalQC;
          });
          const generalQCProgress = (totalQC * 100) / totalAds;
          actions.updateTotalQCAds(qcAdsProgress, generalQCProgress);
          if (adSection && adSection !== null && adSection !== '') {
            actions.updateCompareTotalQCAds(
              qcAdsProgress,
              generalQCProgress,
              adSection
            );
          }
        }

        if (singleQc) {
          if (qc1 === 'true' && qc2 === 'true') {
            qcAdInfo.qc1 = qc1;
            qcAdInfo.qc2 = 'false';
          } else if (qc1 === 'true' && qc2 !== 'true') {
            qcAdInfo.qc1 = 'false';
          } else {
            qcAdInfo.qc1 = 'false';
            qcAdInfo.qc2 = 'false';
          }
        }

        const clearQcresult = await clearAdQC(qcAdInfo);
        const qcObject = this.mapQCServiceObject(clearQcresult);
        const updatedNotes = await this.insertNoteQC(
          adId,
          singleQc ? 'Single QC Clear' : 'QC Clear',
          email,
          fullname,
          2
        );

        if (!singleQc) {
          qcObject.qc1 = 'false';
          qcObject.qc2 = 'false';
        }

        toast('QC Successfully cleared!', {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 2500,
          type: toast.TYPE.SUCCESS,
          hideProgressBar: true
        });

        const newStateAd = {
          ...adPreview,
          adQc: qcObject,
          adNotes: updatedNotes
        };

        const newStateParams = {
          ...this.state,
          showClearModal: false,
          qC: clearQcresult.returnQC,
          allQcBoxesFilled: false,
          cancelOpen: false,
          clearProcessing: false,
          clearAllProcessing: false
        };

        this.setState(newStateParams, () => {
          this.updateParent(newStateAd);
        });
      } else {
        this.setState({
          showClearModal: false,
          cancelOpen: false,
          clearProcessing: false,
          clearAllProcessing: false
        });
      }
    });
  };

  adOnHold = () => {
    const { adPreview, user, setAdPreviewStatus } = this.props;
    const { token } = this.state;
    const {
      ad_id: adPreviewId
      // campaignObjective  //commented out for later use ALEXIA-2592
    } = adPreview;
    const { email, sub } = user;
    const fullname = getFullNameOrUserName(user);

    const holdQc = {
      ad_id: adPreviewId,
      fullname,
      username: email,
      userid: sub
    };

    // this.props.actions.adPreviewAdAccordionIndex(-1, campaignObjective); //commented out for later use ALEXIA-2592

    this.setState(
      {
        ...this.state,
        cancelOpen: false,
        holdOpen: false,
        holdProcessing: true
      },
      async () => {
        const updateAdHoldResult = await updateAdHold(holdQc);

        const qcReturn = this.mapQCServiceObject(updateAdHoldResult);

        const { on_hold: onHold } = qcReturn;
        const adStatus = 'PAUSED'; // always keep ad inactive - ALEXIA-2401
        const message = onHold ? 'Hold Ad' : 'Release Ad';
        const noteType = onHold ? 3 : 5;

        if (setAdPreviewStatus) {
          setAdPreviewStatus(onHold);
        }

        await updateStatusAd(adPreviewId, token, adStatus);
        const updatedNotes = await this.insertNoteQC(
          adPreviewId,
          message,
          email,
          fullname,
          noteType
        );
        toast(`${message}!`, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 2000,
          type: toast.TYPE.SUCCESS,
          hideProgressBar: true
        });

        if (qcReturn.qc1 === null) {
          qcReturn.qc1 = 'false';
        }
        if (qcReturn.qc2 === null) {
          qcReturn.qc2 = 'false';
        }

        const newStateAd = {
          ...adPreview,
          adQc: qcReturn,
          adNotes: updatedNotes,
          getTargetingAndPreviewQueries: true
        };

        if (
          (qcReturn.qc1 !== 'false' || qcReturn.qc1 === null) &&
          (qcReturn.qc2 !== 'false' || qcReturn.qc2 === null)
        ) {
          this.setState({ allQcBoxesFilled: true });
        }

        this.setState(
          (prevState) => ({
            ...prevState,
            holdOpen: false,
            qC: qcReturn,
            qcNote: '',
            holdProcessing: false
          }),
          () => {
            this.updateParent(newStateAd, true);
          }
        );
      }
    );
  };

  isApproveDisable = () => {
    const { qC, hasQC } = this.state;
    if (hasQC) {
      const qcUsers = [qC.qc1Username, qC.qc2Username];
      const userName = this.props.user.email;
      if (qcUsers.indexOf(userName) !== -1) {
        return true;
      }
      return qC.qc1 && qC.qc2;
    }
    return false;
  };
  isClearDisable = () => {
    const { qC, hasQC } = this.state;
    if (hasQC) {
      return !qC.qc1 && !qC.qc2;
    }
    return true;
  };
  renderNotes = (adNotes) => {
    const { user, adPreview } = this.props;
    const { showHistory } = this.state;
    if (adNotes && adNotes.length > 0) {
      return (
        <Accordion>
          <Accordion.Title
            active={showHistory}
            onClick={() => {
              this.setState({ ...this.state, showHistory: !showHistory });
            }}
          >
            <Icon name="dropdown" /> Notes History
          </Accordion.Title>
          <Accordion.Content active={showHistory}>
            <Grid className="notes-history" divided="vertically">
              {adNotes.map((adNote) => (
                <AdNoteDetail
                  key={shortid.generate()}
                  user={user}
                  adNote={adNote}
                  adPreview={adPreview}
                  updateParent={this.updateParent}
                />
              ))}
            </Grid>
          </Accordion.Content>
        </Accordion>
      );
    }
    return null;
  };

  toggleQcPopup = (toggleBool, operation = '') => {
    let newStateProps = {};

    switch (operation) {
      case 'hold':
        newStateProps = {
          holdOpen: toggleBool,
          cancelOpen: false
        };
        break;
      case 'clear':
        newStateProps = {
          holdOpen: false,
          cancelOpen: toggleBool
        };
        break;
      default:
        newStateProps = {
          cancelOpen: false,
          holdOpen: false
        };
        break;
    }

    this.setState(
      {
        ...this.state,
        ...newStateProps,
        qcNote: ''
      },
      () => {
        this.props.actions.adPreviewScrolling(false);
      }
    );
  };

  handleQcNoteChange = (event, data) => {
    this.setState({
      ...this.state,
      qcNote: data.value
    });
  };

  toggleClearQcModal = (qcNote = '') => {
    this.setState({
      ...this.state,
      showClearModal: true,
      holdOpen: false,
      cancelOpen: false,
      qcNote
    });
  };

  render() {
    const adNotes = this.state.notes;
    const {
      currentNote,
      qcNote,
      qcProcessing,
      qcAllProcessing,
      holdOpen,
      qC,
      showClearModal,
      processingSaveNote,
      allQcBoxesFilled,
      cancelOpen,
      clearProcessing,
      clearAllProcessing,
      holdProcessing
    } = this.state;
    const { showCheckboxes, isPreviewActive } = this.props;

    if (qC.qc1 === null || qC.qc1 === undefined) {
      qC.qc1 = 'false';
    }
    if (qC.qc2 === null || qC.qc2 === undefined) {
      qC.qc2 = 'false';
    }

    return (
      <div>
        <Grid stackable doubling>
          <Grid.Row>
            <Grid.Column width={2} />
            <Grid.Column width={6}>
              <Input
                fluid
                placeholder="Add Note"
                value={currentNote}
                onChange={(event, data) => {
                  this.setState({ currentNote: data.value });
                }}
                action={
                  <Button
                    loading={processingSaveNote}
                    onClick={() => {
                      this.handleSave();
                    }}
                    color="blue"
                  >
                    Save
                  </Button>
                }
              />
              {this.renderNotes(adNotes)}
            </Grid.Column>
            <Grid.Column width={4}>
              <Button
                onClick={() => this.approveQc()}
                color="olive"
                loading={qcProcessing}
                disabled={
                  qcAllProcessing ||
                  qcProcessing ||
                  showCheckboxes ||
                  allQcBoxesFilled ||
                  clearProcessing ||
                  clearAllProcessing ||
                  holdProcessing ||
                  allQcBoxesFilled
                }
              >
                Approve
              </Button>
              <Button
                onClick={() => this.approveQc(true)}
                color="green"
                loading={qcAllProcessing}
                disabled={
                  qcAllProcessing ||
                  qcProcessing ||
                  showCheckboxes ||
                  allQcBoxesFilled ||
                  clearProcessing ||
                  clearAllProcessing ||
                  holdProcessing
                }
              >
                Approve All
              </Button>
            </Grid.Column>

            <Grid.Column width={4}>
              <Popup
                flowing
                on="click"
                open={holdOpen && isPreviewActive}
                trigger={
                  <Button
                    disabled={
                      qcProcessing ||
                      qcAllProcessing ||
                      cancelOpen ||
                      clearProcessing ||
                      clearAllProcessing ||
                      holdProcessing
                    }
                    loading={holdProcessing}
                    onClick={() => this.toggleQcPopup(true, 'hold')}
                    color="blue"
                  >
                    {qC.on_hold ? 'Release Ad' : 'Hold Ad'}
                  </Button>
                }
              >
                <Grid>
                  <Grid.Row>
                    <Grid.Column>
                      <Input
                        fluid
                        placeholder="Add Note to release/hold ad"
                        value={qcNote}
                        onChange={this.handleQcNoteChange}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <Button onClick={this.adOnHold} color="blue">
                        Confirm
                      </Button>
                      <Button onClick={() => this.toggleQcPopup(false, 'hold')}>
                        Cancel
                      </Button>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Popup>
              <Popup
                flowing
                on="click"
                position="top center"
                open={cancelOpen && isPreviewActive}
                trigger={
                  <Button
                    loading={clearProcessing || clearAllProcessing}
                    disabled={
                      qcProcessing ||
                      qcAllProcessing ||
                      showCheckboxes ||
                      clearProcessing ||
                      clearAllProcessing ||
                      holdProcessing
                    }
                    onClick={() => this.toggleQcPopup(true, 'clear')}
                    color="red"
                  >
                    Clear QC
                  </Button>
                }
              >
                <Grid>
                  <Grid.Row>
                    <Grid.Column>
                      <Input
                        fluid
                        disabled={clearProcessing || clearAllProcessing}
                        placeholder="Add Note to the clear QC"
                        value={qcNote}
                        onChange={this.handleQcNoteChange}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <Button
                        color="red"
                        disabled={
                          this.isClearDisable() ||
                          clearProcessing ||
                          clearAllProcessing
                        }
                        onClick={() => this.handleClear(true)}
                      >
                        Clear
                      </Button>
                      <Button
                        color="youtube"
                        disabled={
                          this.isClearDisable() ||
                          clearProcessing ||
                          clearAllProcessing
                        }
                        onClick={() => this.toggleClearQcModal(qcNote)}
                      >
                        Clear All
                      </Button>
                      <Button
                        onClick={() => this.toggleQcPopup(false, 'clear')}
                      >
                        Cancel Clear
                      </Button>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Popup>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Modal open={showClearModal} onClose={this.onCloseClearModal}>
          <Modal.Header>Warning Clear All QC</Modal.Header>
          <Modal.Content>
            Are you sure you want to clear QC values for this ad?
            <Input
              fluid
              placeholder="Add Note to Clear QC"
              value={qcNote}
              onChange={this.handleQcNoteChange}
            />
          </Modal.Content>
          <Modal.Actions>
            <Button
              onClick={() => {
                this.handleClear(false);
              }}
              disabled={clearAllProcessing}
              loading={clearAllProcessing}
              color="red"
            >
              Yes
            </Button>
            <Button
              onClick={this.onCloseClearModal}
              disabled={clearAllProcessing}
              loading={clearAllProcessing}
            >
              No
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  const newProps = Object.assign(
    {},
    {
      user: state.user,
      qcProcess: state.adQc.qcProcess,
      isScrolling: state.adPreview.isScrolling,
      showCheckboxes: state.adPreview.showCheckboxes
    }
  );
  return newProps;
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AdNotesQC);



// WEBPACK FOOTER //
// ./src/screens/Flipper/ParentSection/AdNotesQC.js